// Career Stage Utilities Module
// Functions for normalizing and handling career stage data

// Normalize career stage for display (converts "Breakthrough/Established #" to "Established #")
export function normalizeCareerStageDisplay(careerStage: string): string {
  if (!careerStage) return "Emerging";

  const stage = careerStage.toLowerCase();

  // Handle developing/local variants
  if (stage.includes("developing") || stage.includes("local")) {
    return "Developing";
  }

  // Handle Break-through/Established variants - show as "Established #"
  if (stage.includes("break-through") || stage.includes("breakthrough")) {
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Established ${tierMatch[1]}` : "Established";
  }

  // Handle other established variants
  if (stage.includes("established")) {
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Established ${tierMatch[1]}` : "Established";
  }

  // Handle mainstream variants
  if (stage.includes("mainstream")) {
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Mainstream ${tierMatch[1]}` : "Mainstream";
  }

  // Handle emerging
  if (stage.includes("emerging")) {
    return "Emerging";
  }

  // Default to original case if no match
  return careerStage;
}

// Normalize career stage function (handles Break-through/Established variants)
export function normalizeCareerStage(careerStage: string): string {
  if (!careerStage) return "Emerging";

  const stage = careerStage.toLowerCase();

  // Handle developing/local variants - normalize to "Developing"
  if (stage.includes("developing") || stage.includes("local")) {
    return "Developing";
  }

  // Handle Break-through/Established variants
  if (stage.includes("break-through") || stage.includes("breakthrough")) {
    // Extract tier number if present (e.g., "Break-Through/Established 1" → "Established 1")
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Established ${tierMatch[1]}` : "Established";
  }

  // Handle other established variants
  if (stage.includes("established")) {
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Established ${tierMatch[1]}` : "Established";
  }

  // Handle mainstream variants
  if (stage.includes("mainstream")) {
    const tierMatch = careerStage.match(/(\d+)$/);
    return tierMatch ? `Mainstream ${tierMatch[1]}` : "Mainstream";
  }

  // Handle emerging
  if (stage.includes("emerging")) {
    return "Emerging";
  }

  // Default to original case if no match
  return careerStage;
}

export function getCareerStageOptions() {
  return [
    { value: "emerging", label: "Emerging" },
    { value: "breakthrough", label: "Breakthrough" }, 
    { value: "established", label: "Established" },
    { value: "mainstream", label: "Mainstream" }
  ];
}